import { SectionHeader } from "../shared/SectionHeader";
import { ToggleRow } from "../shared/ToggleRow";
import { useEmployeeNotificationPrefs } from "@/hooks/useEmployeeNotificationPrefs";
import { useToast } from "@/hooks/use-toast";

export function EmployeeNotificationSettings() {
  const { prefs, savePrefs } = useEmployeeNotificationPrefs();
  const { toast } = useToast();

  return (
    <>
      <SectionHeader
        title="Notifications"
        description="Only the alerts that matter to your own workday."
      />
      <div className="space-y-0">
        <ToggleRow
          label="Low stock alerts"
          description="Show low-stock warnings that affect your ability to sell from your assigned stock view."
          checked={prefs.lowStockAlertsEnabled}
          onSave={async (value) => {
            try {
              await savePrefs({ lowStockAlertsEnabled: value });
            } catch (error) {
              toast({
                title: "Could not save alert setting",
                description: error instanceof Error ? error.message : "Try again.",
                variant: "destructive",
              });
            }
          }}
        />
        <ToggleRow
          label="Sale confirmation notification"
          description="Show a confirmation after you successfully save a sale."
          checked={prefs.saleConfirmationEnabled}
          onSave={async (value) => {
            try {
              await savePrefs({ saleConfirmationEnabled: value });
            } catch (error) {
              toast({
                title: "Could not save notification setting",
                description: error instanceof Error ? error.message : "Try again.",
                variant: "destructive",
              });
            }
          }}
        />
      </div>
    </>
  );
}
